import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as Menu from '../../../components/menu'
import * as Router from '../../../router'
import * as ReportUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'

type Reducer = ReduxObservable.Epic<Redux.Action, any>
export const searchTopTopics: Reducer = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER, Constants.FormConstants.UPDATE)
    .filter(() => history.location.pathname === Menu.REPORTS_TOPICS_URL)
    .map(store.getState)
    .filter((state) => ReportUtils.validDateRange(state.reports.topTopics.form))
    .map((state) => {
      return Actions.fetchTopTopics(state.app.selectedCommunity, state.reports.topTopics.form)
    })

export const epic = ReduxObservable.combineEpics(searchTopTopics)



// WEBPACK FOOTER //
// ./src/pages/reports/top-topics/epic.ts